import { render, staticRenderFns } from "./FobPointFormElement.vue?vue&type=template&id=3f39c976"
import script from "./FobPointFormElement.vue?vue&type=script&lang=js"
export * from "./FobPointFormElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f39c976')) {
      api.createRecord('3f39c976', component.options)
    } else {
      api.reload('3f39c976', component.options)
    }
    module.hot.accept("./FobPointFormElement.vue?vue&type=template&id=3f39c976", function () {
      api.rerender('3f39c976', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/Administration/Suppliers/FobPoints/FobPointFormElement.vue"
export default component.exports